<template>
  <div class="about container">
    <div class="item item1">
      <div class="wrap">
        <div class="img-box">
          <img class="w-240" src="@/assets/about/js12.png" alt />
        </div>
        <div class="m-t32 mb-24 img-box">
          <img class="w-320" src="@/assets/about/js1.png" alt />
        </div>
        <div class="check">
          <img class="w-16" src="@/assets/about/js13.png" alt />
          <div>企业多员工统一在线寄件、统一结算管理</div>
        </div>
        <div class="check">
          <img class="w-16" src="@/assets/about/js13.png" alt />
          <div>个人用户在线寄包裹，退货寄件和跟踪管理</div>
        </div>
        <div class="check">
          <img class="w-16" src="@/assets/about/js13.png" alt />
          <div>支持运费预存统一支付、线下支付等灵活结算方式</div>
        </div>
        <div class="check">
          <img class="w-16" src="@/assets/about/js13.png" alt />
          <div>支持顺丰、京东、邮政、申通、韵达等常用快递</div>
        </div>
      </div>
      <div class="bg">
        <img class="w-414" src="@/assets/about/js2.png" alt />
      </div>
    </div>
    <div class="item item2">
      <div class="title">
        行政前台快速批量寄件
        <br />节省50%工作时间
      </div>
      <div class="mt-20">
        <img class="w-270" src="@/assets/about/js4.png" alt />
      </div>
      <ul class="box">
        <li>
          <div class="fs-b fs-15">批量下单</div>
          <div class="gray fs-10 mt6">支持多个收件客户批量下单</div>
        </li>
        <li>
          <div class="fs-b fs-15">快捷</div>
          <div class="gray fs-10 mt6">寄合同、样品更方便快捷</div>
        </li>
        <li>
          <div class="fs-b fs-15">实时反馈</div>
          <div class="gray fs-10 m-t6">在线下单, 预约快递员上门揽件</div>
        </li>
        <li>
          <div class="fs-b fs-15">灵活寄件方式</div>
          <div class="gray fs-10 m-t6">手动录入/批量导入/多条寄件等</div>
        </li>
      </ul>
    </div>
    <div class="item item3">
      <div class="title">
        公司统一管理 员工集中使用
        <br />透明化流程，行政管理更轻松
      </div>
      <div class="mt-20">
        <img class="w-270" src="@/assets/about/js7.png" alt />
      </div>
      <ul class="box">
        <li>
          <div class="fs-b fs-15">集中</div>
          <div class="gray fs-10 m-t6">多部门多员工一起寄件</div>
        </li>
        <li>
          <div class="fs-b fs-15">省时</div>
          <div class="gray fs-10 m-t6">多种结算方式灵活操作</div>
        </li>
        <li>
          <div class="fs-b fs-15">易用</div>
          <div class="gray fs-10 m-t6">多种场景寄件均可满足</div>
        </li>
        <li>
          <div class="fs-b fs-15">提效</div>
          <div class="gray fs-10 m-t6">统一配置管理 集中对账</div>
        </li>
      </ul>
    </div>
    <div class="item item2">
      <div class="title">
        员工对公寄件更方便
        <br />不用使用多个app或小程序
      </div>
      <div class="mt-20">
        <img class="w-270" src="@/assets/about/js5.png" alt />
      </div>
      <ul class="box">
        <li>
          <div class="fs-b fs-15">一键下单</div>
          <div class="gray fs-10 m-t6">多家快递公司一键下单</div>
        </li>
        <li>
          <div class="fs-b fs-15">省时</div>
          <div class="gray fs-10 m-t6">不用花时间找多个快递APP下单</div>
        </li>
        <li>
          <div class="fs-b fs-15">支持多家</div>
          <div class="gray fs-10 m-t6">顺丰/京东/邮政/申通等公司</div>
        </li>
        <li>
          <div class="fs-b fs-15">简便</div>
          <div class="gray fs-10 m-t6">自动保存收寄信息，免手动录入</div>
        </li>
      </ul>
    </div>
    <div class="item item3">
      <div class="title">
        财务统一管理与报销
        <br />员工免报销流程 无纸化管理
      </div>
      <div class="mt-20">
        <img class="w-270" src="@/assets/about/js6.png" alt />
      </div>
      <ul class="box">
        <li>
          <div class="fs-b fs-15">多种对账方式</div>
          <div class="gray fs-10 m-t6">支持按部门/快递公司统计对账</div>
        </li>
        <li>
          <div class="fs-b fs-15">存档分析</div>
          <div class="gray fs-10 m-t6">可导出客户信息进行存档分析</div>
        </li>
        <li>
          <div class="fs-b fs-15">统一结算</div>
          <div class="gray fs-10 m-t6">统一预存运费统一结算</div>
        </li>
        <li>
          <div class="fs-b fs-15">增值服务</div>
          <div class="gray fs-10 m-t6">支持签回单、保价等增值服务</div>
        </li>
      </ul>
    </div>
    <div class="item item2">
      <div class="title">适用场景</div>
      <ul class="box1">
        <li>
          <div class="left">
            <img src="@/assets/about/js8.png" alt />
          </div>
          <div class="right">
            <div class="fs-b fs-15">公司寄件</div>
            <div class="gray fs-12 m-t4">公司统一寄合同、文件、发票、礼品…</div>
          </div>
        </li>
        <li>
          <div class="left">
            <img src="@/assets/about/js9.png" alt />
          </div>
          <div class="right">
            <div class="fs-b fs-15">分部门寄件</div>
            <div class="gray fs-12 m-t4">可分部门/员工子账号独立在线寄件</div>
          </div>
        </li>
        <li>
          <div class="left">
            <img src="@/assets/about/js10.png" alt />
          </div>
          <div class="right">
            <div class="fs-b fs-15">私人寄件</div>
            <div class="gray fs-12 m-t4">个人寄物品、退换货寄件</div>
          </div>
        </li>
        <li>
          <div class="left">
            <img src="@/assets/about/js11.png" alt />
          </div>
          <div class="right">
            <div class="fs-b fs-15">多场景寄件</div>
            <div class="gray fs-12 m-t4">满足企业、仓库、工厂等多场景寄件</div>
          </div>
        </li>
      </ul>
    </div>
    <div class="item item3 item4">
      <div class="title">如何向公司或老板介绍企业寄件</div>
      <div class="box3" v-html="copyMsg">
      </div>
      <!-- <div class="btn">
        <a-button type="primary" block @click="copy">复制以上内容</a-button>
      </div> -->
    </div>
    <div class="item item2 item4">
      <div class="title">如何向员工推荐企业寄件</div>
      <div class="box3 box4" v-html="copyMsg1">
      </div>
      <!-- <div class="btn">
        <van-button type="primary" block @click="copy1">复制以上内容</van-button>
      </div> -->
    </div>
    <div class="item item4 item5">
      <div class="title">1分钟上手 简单易用</div>
      <div class="mt-20 m-b25">
        公司注册设置，全员即可使用
        <br />3万多家中小企业的选择
      </div>
     
      <div class="fs-12 zx">服务咨询: 400-9633-321  QQ群: 1104611646</div>
      <div class="bg">
        <img src="@/assets/about/js3.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  components: {},
  data() {
    return {
      copyMsg: `尊敬的老板，我了解到一套快递鸟企业寄件系统，系统本身是免费的，感觉比较适合我们公司推荐一下：<br>
            1、简单来说，是一套在线统一寄件、统一管理的寄快递系统，帮助企业实现集中发货管理、统一管理；<br>
            2、特别适合企业中有寄文件、寄发票、寄礼品的使用场景，支持顺丰、京东、邮政、申通、韵达、圆通等常用快递公司；<br>
            3、公司使用这套寄件系统后，行政或前台可统一批量寄快递，员工也可以自己使用，包括对公寄件和私人寄件使用；<br>
            4、目前已经有很多企业公司都在使用这套系统，我建议咱们公司行政同学去了解一下；<br>
            5、详细了解：http://b.kdniao.com`,
      copyMsg1: `亲爱的小伙伴们，我们即将启用全新的“企业寄件”系统，到时候大家可以通过公司提供的网址或二维码使用：<br>
          1、可以使用因公寄件、个人寄件等场景<br>
          2、平时寄文件、寄发票、寄电商退货的都可以使用，支持顺丰、京东、邮政、申通、韵达、圆通等常用快递公司<br>
          3、不定期会有寄件优惠券使用，另行通知<br>
          4、我们会给所有员工分配子账号，登录http://b.kdniao.com使用`
    }
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    copy() {
      const msg = this.copyMsg.replace(/\s*/g, '').replace(/<br>/g, '\n')
      this.$tool.copy(msg)
    },
    copy1() {
      const msg = this.copyMsg1.replace(/\s*/g, '').replace(/<br>/g, '\n')
      this.$tool.copy(msg)
    },
    async addAction() {
      window.location.href = '/#/register'
      await this.$store.dispatch('user/logout')
    }
  }
}
</script>

<style scoped lang="scss">
.about {
  padding: 0;
}
  ul{
   
    list-style: none;

  }
.item {
  background:#4367dc;
  line-height:24px;
  padding: 40px 0;
  text-align: center;
  .title {
    color: #1890ff;
    font-size: 22px;
    line-height: 30px;
  }
  .box {
    text-align: left;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 24px;
    li {
      border: 1px solid #1890ff;
      border-radius: 4px;
      width: 208px;
      padding: 10px;
      margin-right: 10px;
      margin-bottom: 10px;
      white-space: nowrap;
    }
  }
  .box1 {
    text-align: left;
    padding: 0 38px;
    margin-top: 40px;
    li {
      display: flex;
      background: #f0f5ff;
      height: 62px;
      align-items: center;
      margin-bottom: 24px;
      .left {
        width: 90px;
        img {
          width: 90px;
        }
        margin-right: 14px;
      }
    }
  }
  .box3 {
    background: #fff;
    padding: 20px;
    color: #66523d;
    text-align: left;
    line-height: 24px;
    margin-bottom: 55px;
    margin-top: 24px;
  }
  .box4{
    background:#FBF4E1;
  }
  .btn {
    margin-bottom: 15px;
  }
}
.item1 {
  height: 512px;
  position: relative;
  .wrap {
    position: relative;
    z-index: 2;
  }
  .bg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }
  .check {
    display: block;
    line-height: 28px;
    img {
      display: inline-block;
    }
    div {
      font-size: 14px;
      color: #fff;
      display: inline-block;
      vertical-align: middle;
      padding-left: 10px;
    }
  }
}
.item2 {
  background: #fff;
}
.item3 {
  background: #f0f5ff;
}
.item4 {
  padding: 40px 38px;
}
.item5{
  color:#fff;
  background:linear-gradient(#4573E4,#3C60DE);
  .title{
    color:#fff;
  }
  .btn{
    position:relative;
    z-index: 10;
    button{
      background:#fff;
      color:#467DB9;
      height:46px;
      line-height:46px;
      padding:0 15px;
      width:100%;
      font-size:18px;
      border-radius: 5px;
    }
    button:active{
      background:#f8f8f8;
    }
  }

  .zx{
    position: relative;
    z-index: 10;
  }
  .bg{
    position:absolute;
    bottom:0;
    left:0;
    img{
      width:414px;
    }
  }
}
</style>
